import { render, staticRenderFns } from "./JuniorDevelopmentInfo.vue?vue&type=template&id=56fd9f59&scoped=true"
import script from "./JuniorDevelopmentInfo.vue?vue&type=script&lang=js"
export * from "./JuniorDevelopmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd9f59",
  null
  
)

export default component.exports